<template>
  <div>
    <div v-if="isCalendarOpened && window.size.desktop" class="z-backdrop fixed left-0 top-0 w-full h-full outline-none !bg-black/40"></div>
    <div class="flex items-center justify-between mb-4 px-2 xl:px-0">
      <div v-for="post in reversedTdPosts" :key="post.date"
           class="w-[53px] h-10 flex flex-col items-center justify-center border border-zt-light rounded-[10px]
             overflow-hidden duration-300 transition-colors xl:w-[59px] xl:h-[45px]"
           :class="[
             WP.id === Number(post.id) ? '!opacity-100 bg-zt-light text-white font-semibold' : 'text-zt-more',
             post.id ? 'opacity-70 cursor-pointer' : 'opacity-25',
             { 'hover:bg-zt-light/25': post.id && WP.id !== Number(post.id) }
           ]"
           @click="handleClick(post.id)">
        <span class="font-semibold text-xs xl:text-sm">
          {{ getButtonDate(post).date }}
        </span>
        <span class="-mt-0.5 text-[10px] uppercase xl:text-xs">
          {{ getButtonDate(post).day }}
        </span>
      </div>
      <div ref="calendarTD"
           class="w-[53px] h-[40px] relative inline-flex rounded-[10px] shrink-0 items-center justify-center duration-300
             transition-colors cursor-pointer border border-zt-light/70 xl:w-[59px] xl:h-[45px]"
           :class="isCalendarOpened ? 'bg-zt-light' : 'hover:bg-zt-light/25'"
           @click="handleOpenCalendar"
           v-click-outside="() => { window.size.desktop && isCalendarOpened ? handleCloseCalendar() : null; }">
        <svg class="w-[33px] h-[33px] xl:w-[41px] xl:h-[41px]" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.3125 6.40625H7.6875C5.56466 6.40625 3.84375 8.12716 3.84375 10.25V33.3125C3.84375 35.4353 5.56466 37.1562 7.6875 37.1562H33.3125C35.4353 37.1562 37.1562 35.4353 37.1562 33.3125V10.25C37.1562 8.12716 35.4353 6.40625 33.3125 6.40625Z" stroke="#93A3BA" stroke-linejoin="round" />
          <path d="M23.6449 20.3835C24.6741 20.3835 25.5085 19.5491 25.5085 18.5199C25.5085 17.4906 24.6741 16.6562 23.6449 16.6562C22.6156 16.6562 21.7812 17.4906 21.7812 18.5199C21.7812 19.5491 22.6156 20.3835 23.6449 20.3835Z" fill="#93A3BA" />
          <path d="M30.0511 20.3835C31.0804 20.3835 31.9148 19.5491 31.9148 18.5199C31.9148 17.4906 31.0804 16.6562 30.0511 16.6562C29.0219 16.6562 28.1875 17.4906 28.1875 18.5199C28.1875 19.5491 29.0219 20.3835 30.0511 20.3835Z" fill="#93A3BA" />
          <path d="M23.6449 26.7898C24.6741 26.7898 25.5085 25.9554 25.5085 24.9261C25.5085 23.8969 24.6741 23.0625 23.6449 23.0625C22.6156 23.0625 21.7812 23.8969 21.7812 24.9261C21.7812 25.9554 22.6156 26.7898 23.6449 26.7898Z" fill="#93A3BA" />
          <path d="M30.0511 26.7898C31.0804 26.7898 31.9148 25.9554 31.9148 24.9261C31.9148 23.8969 31.0804 23.0625 30.0511 23.0625C29.0219 23.0625 28.1875 23.8969 28.1875 24.9261C28.1875 25.9554 29.0219 26.7898 30.0511 26.7898Z" fill="#93A3BA" />
          <path d="M10.8324 26.7898C11.8616 26.7898 12.696 25.9554 12.696 24.9261C12.696 23.8969 11.8616 23.0625 10.8324 23.0625C9.80313 23.0625 8.96875 23.8969 8.96875 24.9261C8.96875 25.9554 9.80313 26.7898 10.8324 26.7898Z" fill="#93A3BA" />
          <path d="M17.2386 26.7898C18.2679 26.7898 19.1023 25.9554 19.1023 24.9261C19.1023 23.8969 18.2679 23.0625 17.2386 23.0625C16.2094 23.0625 15.375 23.8969 15.375 24.9261C15.375 25.9554 16.2094 26.7898 17.2386 26.7898Z" fill="#93A3BA" />
          <path d="M10.8324 33.196C11.8616 33.196 12.696 32.3616 12.696 31.3324C12.696 30.3031 11.8616 29.4688 10.8324 29.4688C9.80313 29.4688 8.96875 30.3031 8.96875 31.3324C8.96875 32.3616 9.80313 33.196 10.8324 33.196Z" fill="#93A3BA" />
          <path d="M17.2386 33.196C18.2679 33.196 19.1023 32.3616 19.1023 31.3324C19.1023 30.3031 18.2679 29.4688 17.2386 29.4688C16.2094 29.4688 15.375 30.3031 15.375 31.3324C15.375 32.3616 16.2094 33.196 17.2386 33.196Z" fill="#93A3BA" />
          <path d="M23.6449 33.196C24.6741 33.196 25.5085 32.3616 25.5085 31.3324C25.5085 30.3031 24.6741 29.4688 23.6449 29.4688C22.6156 29.4688 21.7812 30.3031 21.7812 31.3324C21.7812 32.3616 22.6156 33.196 23.6449 33.196Z" fill="#93A3BA" />
          <path d="M10.25 3.84375V6.40625M30.75 3.84375V6.40625" stroke="#93A3BA" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M37.1562 12.8125H3.84375" stroke="#93A3BA" stroke-linejoin="round" />
        </svg>
        <Transition name="fade">
          <div v-if="window.size.desktop && isCalendarOpened" class="absolute top-full -right-2 translate-y-4 z-10 xl:z-modal">
            <BetsCalendarModal :selected-date="selectedDate" @close-calendar="handleCloseCalendar" />
          </div>
        </Transition>
        <div v-if="isCalendarOpened && window.size.mobile" class="z-modal">
          <div :class="{ 'top-[32px]': WP.user.adminBar }"
               class="bg-[#283344] left-0 w-full h-full overflow-y-hidden fixed z-modal top-0 rounded-zt border border-zt-light shadow-zt">
            <div class="flex items-center border-b border-zt-light pl-4 pr-3.5 h-[55px] gap-4">
              <span class="font-semibold">Kalendarz</span>
              <div
                class="x-close-modal"
                @click.stop="
                  isCalendarOpened = false;
                  this.unblockScrolling();
                "></div>
            </div>
            <div class="overflow-y-auto h-[calc(100%-55px)] flex flex-col justify-between" :class="{ '!h-[calc(100%-87px)]': WP.user.adminBar }">
              <BetsCalendarModal :selected-date="selectedDate" @close-calendar="handleCloseCalendar" />
              <button class="px-4 py-3 mb-4 bg-zt-light border-zt-light rounded-zt zt-hover mx-5" @click.stop="handleOpenCalendar(false)">
                <span class="text-sm font-semibold">ZAMKNIJ OKNO</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BetsCalendarModal from '../../components/modals/BetsCalendarModal.vue';
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: 'BetsCalendar',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    BetsCalendarModal
  },
  data() {
    return {
      selectedDate: DateTime.now().startOf('day'),
      isCalendarOpened: false
    };
  },
  mounted() {
    this.selectedDate = this.getSelectedDate();
  },
  computed: {
    reversedTdPosts() {
      let posts = [...this.WP.tdPosts];

      while (posts.length < 7) {
        const lastPost = posts[0];
        const lastDate = DateTime.fromFormat(lastPost.date, 'yyyy-MM-dd HH:mm:ss');
        const nextDate = lastDate.plus({ days: 1 }).toFormat('yyyy-MM-dd HH:mm:ss');

        posts.unshift({
          date: nextDate
        });
      }

      if (window.size.mobile) {
        posts.shift();
        posts.pop();
      }

      return posts.reverse();
    }
  },
  methods: {
    getButtonDate(post) {
      if (!post) {
        return '---';
      }

      const postDate = new Date(post.date);
      const today = new Date();
      const date = postDate.getDate();
      const month = (postDate.getMonth() + 1).toString().padStart(2, '0');
      const formattedDate = `${date}.${month}`;

      const isToday = postDate.getDate() === today.getDate() && postDate.getMonth() === today.getMonth() && postDate.getFullYear() === today.getFullYear();

      if (isToday) {
        return {
          date: formattedDate,
          day: 'DZIŚ'
        };
      }

      const weekdays = ['Ndz', 'Pon', 'Wto', 'Śro', 'Czw', 'Pią', 'Sob'];
      const day = weekdays[postDate.getDay()];

      return {
        date: formattedDate,
        day: day
      };
    },
    handleOpenCalendar() {
      this.isCalendarOpened = !this.isCalendarOpened;
      if (this.isCalendarOpened) {
        if (window.size.desktop) {
          this.$refs.calendarTD.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.blockScrolling();
      } else {
        this.unblockScrolling();
      }
    },
    handleClick(postId) {
      if (postId) {
        window.location.href = `/?p=${postId}`;
      }
    },
    handleCloseCalendar() {
      this.isCalendarOpened = false;
      this.unblockScrolling();
    },
    getSelectedDate() {
      const selectedPost = this.WP.tdPosts.find(post => Number(post.id) === this.WP.id);
      if (selectedPost) {
        return DateTime.fromFormat(selectedPost.date, 'yyyy-MM-dd HH:mm:ss');
      }
      return null;
    }
  }
};
</script>

<style scoped>

</style>